import Link from "next/link";
import { ListingModalPlanOptionsWrapper } from "./ListingModalPlanOptionsWrapper";
import { ListingModalPlanOptionsTitle } from "./ListingModalPlanOptionsTitle";
import { ListingModalPlanOptionsSubtitle } from "./ListingModalPlanOptionsSubtitle";
import { ListingModalPlanContentWrapper } from "./ListingModalPlanContentWrapper";
import { ListingModalContent } from "./ListingModalContent";
import { ListingModalPlanRedirect } from "./ListingModalPlanRedirect";

export const ListingModalPlanOptions = () => {
  return (
    <ListingModalPlanOptionsWrapper>
      <ListingModalPlanOptionsTitle>Get Started</ListingModalPlanOptionsTitle>
      <ListingModalPlanOptionsSubtitle>
        Purchase or borrow this training plan
      </ListingModalPlanOptionsSubtitle>

      <ListingModalPlanContentWrapper>
        <ListingModalContent />
      </ListingModalPlanContentWrapper>

      <Link href={"/payment"}>
        <ListingModalPlanRedirect>
          More about memberships
        </ListingModalPlanRedirect>
      </Link>
    </ListingModalPlanOptionsWrapper>
  );
};
